import React from 'react';
import { Button } from 'reactstrap';

export default class IconButton extends React.Component {
  render() {
    const { color = 'primary', title, children, ...rest } = this.props;
    return (
      <Button color={color} {...rest}>
        {children}
        {title}
      </Button>
    );
  }
}
